<template>
	<div>
		<modalDetail :dialog="dialog" @hideDialog="() => { dialog = false }"></modalDetail>
		<modalPrint :dialog="dialogPrint" @hideDialog="() => { dialogPrint = false }"></modalPrint>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Approval Sales Order</div>
		</div>
		<div v-if="loading">
			<loading-card></loading-card>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3" outlined>
				<v-list color="grey lighten-3" class="pa-3">
					<v-list-item dense class="px-1">
						<div>
							<v-tabs color="primary" background-color="grey lighten-3" class="change-display" height="40">
								<v-tab @click="cardDisplay = false">
									<v-icon>mdi-table</v-icon>
								</v-tab>
								<v-tab @click="cardDisplay = true">
									<v-icon>mdi-card-bulleted</v-icon>
								</v-tab>
							</v-tabs>
						</div>
						<v-spacer></v-spacer>
						<v-btn text depressed class="primary mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mt-3" v-if="dropfilter">
					<v-col class="px-4 pb-1">
						<v-row>
							<v-col cols="12" md="4">
								<v-text-field dense outlined hide-details label="Kode SO" v-model="codeSO.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="4">
								<v-menu v-model="menuDatePay" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(tanggalDibayar)" label="Tanggal Dibayar" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
									</template>
									<v-date-picker range color="primary" v-model="tanggalDibayar"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="4">
								<v-text-field dense outlined hide-details label="Kode Pelanggan(MB)" v-model="codeMB.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="4">
								<v-autocomplete outlined dense hide-details v-model="customer_province.value" :items="ProvinceOption" label="Provinsi" item-text="province" item-value="province_id" no-data-text="Tidak ada data yang sesuai" @change="changeProvince">
									<template v-slot:item = {item}>
										<span v-if="item.province_id">Provinsi {{ item.province }}</span>
										<span v-else>{{ item.province }}</span>
									</template>
									<template v-slot:selection = {item}>
										<span v-if="item.province_id">Provinsi {{ item.province }}</span>
										<span v-else>{{ item.province }}</span>
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12" md="4">
								<v-autocomplete outlined dense hide-details v-model="customer_city.value" :items="CityOption" label="Kota" placeholer="ini kota" item-text="city_name" item-value="city_id" no-data-text="Tidak ada data yang sesuai" @change="changeCity">
									<template v-slot:item = {item}>
										<span v-if="item.city_id">{{ item.type }} {{ item.city_name }}</span>
										<span v-else>{{ item.city_name }}</span>
									</template>
									<template v-slot:selection = {item}>
										<span v-if="item.city_id">{{ item.type }} {{ item.city_name }}</span>
										<span v-else>{{ item.city_name }}</span>
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12" md="4">
								<v-autocomplete outlined dense hide-details v-model="customer_subdistrict.value" :items="SubdistrictOption" label="Kecamatan" item-text="subdistrict_name" item-value="subdistrict_id" no-data-text="Tidak ada data yang sesuai">
									<template v-slot:item = {item}>
										<span v-if="item.subdistrict_id">Kecamatan {{ item.subdistrict_name }}</span>
										<span v-else>{{ item.subdistrict_name }}</span>
									</template>
									<template v-slot:selection = {item}>
										<span v-if="item.subdistrict_id">Kecamatan {{ item.subdistrict_name }}</span>
										<span v-else>{{ item.subdistrict_name }}</span>
									</template>
								</v-autocomplete>
							</v-col>
						</v-row>
					</v-col>
					<v-card-actions class="px-4 pb-3">
						<v-spacer></v-spacer>
						<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter">Reset</v-btn>
						<v-btn depressed color="primary" dark class="ml-2 text-capitalize" @click="cari">Cari</v-btn>
					</v-card-actions>
				</v-card>
			</v-slide-y-transition>
			<div v-if="!cardDisplay">
				<v-card outlined class="mt-3" v-if="listSO.length > 0">
					<template>
						<v-data-table hide-default-footer disable-pagination class="white-row custom-table table-w-110" :headers="headers" :items="listSO" :options.sync="option" :server-items-length="soPagination.total_data" :single-expand="false" :expanded.sync="expanded" item-key="so_code" :show-expand="true">
							<template v-slot:item.action="{ item }">
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn class="mr-1" fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(item.so_code)">
											<v-icon dark>mdi-text-box-search</v-icon>
										</v-btn>
									</template>
									<span>Detail</span>
								</v-tooltip>
								<v-tooltip bottom v-if="hasAccess('approval-sales-order')">
									<template v-slot:activator="{ on, attrs }">
										<router-link class="text-deco" :to="{ name: 'approval-sales-order', params: { code: item.so_code }}">
											<v-btn fab dark x-small depressed color="indigo lighten-2" v-bind="attrs" v-on="on">
												<v-icon dark>mdi-check</v-icon>
											</v-btn>
										</router-link>
									</template>
									<span>Approval SO</span>
								</v-tooltip>
							</template>
							<template v-slot:item.so_status_created_datetime="{ item }">
								<div class="py-2">{{ item.so_status_created_datetime | tanggaljam }}</div>
							</template>
							<template v-slot:item.so_status_paid_datetime="{ item }">
								<div>{{ item.so_status_paid_datetime | tanggaljam }}</div>
							</template>
							<template v-slot:item.so_status="{ item }">
								<div>{{ item.so_status | toStatusSOWH }}</div>
							</template>
							<template v-slot:item.customer_info="{ item }">
								<div class="py-2">
									<div class="d-flex">
										<div>{{ item.customer_network_code }}</div>
										<div class="px-1">-</div>
										<div>{{ item.customer_name }}</div>
										<div class="px-1">-</div>
										<div>{{ item.customer_mobilephone }}</div>
									</div>
									<div class="pt-1">{{ addressText(item) }}</div>
								</div>
							</template>
							<template v-slot:expanded-item="{ headers, item }">
								<td class="px-0" :colspan="headers.length">
									<v-card tile class="elevation-0">
										<v-simple-table class="white-row" no-data-text="Belum ada data tersedia">
											<template v-slot:default>
												<thead>
													<tr>
														<th width="25%" class="px-4 text-left">Nama Produk</th>
														<th width="25%" class="px-4 text-center">Jumlah Dipesan</th>
														<th width="25%" class="px-4 text-center">Jumlah Diterima</th>
														<th width="25%" class="px-4 text-center">Jumlah Dikirim</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="product in item.so_detail" :key="product.so_detail_id">
														<td class="px-4 text-left">
															<div class="font-size-10">{{ product.so_detail_product_name }}</div>
														</td>
														<td class="px-4 text-center">
															<div class="font-size-10">{{ product.so_detail_quantity_sold | toNumber }} {{product.so_detail_product_unit}}</div>
														</td>
														<td class="px-4 text-center">
															<div class="font-size-10">{{ product.so_detail_quantity_received | toNumber }} {{product.so_detail_product_unit}}</div>
														</td>
														<td class="px-4 text-center">
															<div class="font-size-10">{{ product.so_detail_quantity_transport | toNumber }} {{product.so_detail_product_unit}}</div>
														</td>
													</tr>
												</tbody>
											</template>
										</v-simple-table>
									</v-card>
								</td>
							</template>
						</v-data-table>
					</template>
				</v-card>
			</div>
			<div v-if="cardDisplay">
				<v-row class="mr-0" v-if="listSO.length > 0">
					<v-col cols="12" md="12" class="pb-0 pr-0" v-for="listso in listSO" :key="listso.so_id">
						<v-card outlined>
							<v-list color="grey lighten-3" class="pt-0 pb-0">
								<v-list-item dense>
									<v-list-item-content class="grey--text text--darken-2">
										Kode Sales Order {{ listso.so_code  }}
									</v-list-item-content>
									<v-spacer></v-spacer>
									<v-btn small text depressed class="primary" @click="printSO(listso.so_code)" v-if="false">
										<v-icon>mdi-printer</v-icon>
										<div class="pl-2 text-capitalize">Print</div>
									</v-btn>
								</v-list-item>
							</v-list>
							<v-list-item>
								<v-list-item-content>
									<v-layout wrap v-if="false">
										<v-flex xs6 sm4 md4>
											<div class="body-2 oppacity-75">Kode Pelanggan</div>
											<div class="subtitle-2">{{ listso.customer_network_code }}</div>
											<div class="body-2 pt-3 oppacity-75">Tanggal Dibuat</div>
											<div class="subtitle-2">{{ listso.so_status_created_datetime | tanggaljam }}</div>
										</v-flex>
										<v-flex xs6 sm4 md4>
											<div class="body-2 oppacity-75">Approval Pembayaran Oleh</div>
											<div class="subtitle-2">{{ listso.so_status_paid_user_name ? listso.so_status_paid_user_name : '-' }}</div>
											<div class="body-2 pt-3 oppacity-75">Tanggal Dibayar</div>
											<div class="subtitle-2">{{ listso.so_status_paid_datetime | tanggaljam }}</div>
										</v-flex>
										<v-flex xs6 sm4 md4>
											<div class="body-2 oppacity-75">Status</div>
											<div class="subtitle-2">{{ listso.so_status | toStatusSOWH }}</div>
											<div class="pt-5">
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn class="mr-2" fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(listso.so_code)">
															<v-icon dark>mdi-text-box-search</v-icon>
														</v-btn>
													</template>
													<span>Detail</span>
												</v-tooltip>
												<v-tooltip bottom v-if="hasAccess('approval-sales-order')">
													<template v-slot:activator="{ on, attrs }">
														<router-link class="text-deco" :to="{ name: 'approval-sales-order', params: { code: listso.so_code }}">
															<v-btn fab dark x-small depressed color="indigo lighten-2" v-bind="attrs" v-on="on">
																<v-icon dark>mdi-check</v-icon>
															</v-btn>
														</router-link>
													</template>
													<span>Approval SO</span>
												</v-tooltip>
											</div>
										</v-flex>
									</v-layout>
									<v-layout wrap>
										<v-flex xs6 sm3 md2 class="pr-3">
											<div class="body-2 oppacity-75">Kode Pelanggan</div>
											<div class="subtitle-2">{{ listso.customer_network_code }}</div>
										</v-flex>
										<v-flex xs6 sm3 md2 class="pr-3">
											<div class="body-2 oppacity-75">Nama Pelanggan</div>
											<div class="subtitle-2">{{ listso.customer_name }}</div>
										</v-flex>
										<v-flex xs6 sm3 md2 class="pr-3">
											<div class="body-2 oppacity-75">Nomor Handphone</div>
											<div class="subtitle-2">{{ listso.customer_mobilephone }}</div>
										</v-flex>
										<v-flex xs6 sm3 md2 class="pr-3">
											<div class="body-2 oppacity-75">Tanggal Dibayar</div>
											<div class="subtitle-2">{{ listso.so_status_paid_datetime | tanggaljam }}</div>
										</v-flex>
										<v-flex xs6 sm3 md2 class="pr-3">
											<div class="body-2 pt-4 pt-md-0 oppacity-75">Status</div>
											<div class="subtitle-2">{{ listso.so_status | toStatusSOWH }}</div>
										</v-flex>
										<v-flex xs6 sm6 md6 class="pr-3">
											<div class="body-2 pt-4 oppacity-75">Alamat</div>
											<div class="subtitle-2">{{ addressText(listso) }}</div>
										</v-flex>
										<v-flex xs4 sm4 md4 class="pr-3 pt-1">
											<div class="pt-5 d-flex">
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn class="mr-2" fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(listso.so_code)">
															<v-icon dark>mdi-text-box-search</v-icon>
														</v-btn>
													</template>
													<span>Detail</span>
												</v-tooltip>
												<v-tooltip bottom v-if="hasAccess('approval-sales-order')">
													<template v-slot:activator="{ on, attrs }">
														<router-link class="text-deco" :to="{ name: 'approval-sales-order', params: { code: listso.so_code }}">
															<v-btn fab dark x-small depressed color="indigo lighten-2" v-bind="attrs" v-on="on">
																<v-icon dark>mdi-check</v-icon>
															</v-btn>
														</router-link>
													</template>
													<span>Approval SO</span>
												</v-tooltip>
											</div>
										</v-flex>
									</v-layout>
								</v-list-item-content>
							</v-list-item>
							<div class="pt-2">
								<v-card tile elevation="0">
									<v-data-table :headers="headersProduct" :items="listso.so_detail" :items-per-page="1000" class="elevation-0 white-row" hide-default-footer>
										<template v-slot:item.so_detail_quantity_sold="{ item }">
											<div>{{ item.so_detail_quantity_sold | toNumber }} {{item.so_detail_product_unit}}</div>
										</template>
										<template v-slot:item.so_detail_quantity_received="{ item }">
											<div>{{ item.so_detail_quantity_received | toNumber }} {{item.so_detail_product_unit}}</div>
										</template>
										<template v-slot:item.so_detail_quantity_transport="{ item }">
											<div>{{ item.so_detail_quantity_transport | toNumber }} {{item.so_detail_product_unit}}</div>
										</template>
									</v-data-table>
								</v-card>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</div>
			<v-card outlined class="mt-3" v-if="listSO.length == 0 && soPagination">
				<div class="py-3">
					<not-found></not-found>
				</div>
			</v-card>
			<div class="pt-5" v-if="soPagination.total_page > 1 && listSO.length > 0">
				<v-row v-if="soPagination">
					<v-col cols="12" md="11" class="py-0 d-flex justify-end">
						<v-pagination v-model="page" @input="changePage" :length="soPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus"></v-pagination>
					</v-col>
					<v-col cols="12" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import {mapActions,  mapState, mapMutations} from 'vuex'
import modalDetail from '@/views/MLwarehouse/so/DetailSO'
import modalPrint from '@/views/MLwarehouse/so/ModalPrintSO'

export default {
	components: {
		modalDetail, modalPrint
	},
	data() {
		return {
			cardDisplay: false,
			expanded: [],
			dialog: false,
			dialogPrint: false,
			dropfilter: false,
			menuDateCreate: false,
			menuDatePay: false,
			loading: true,
			soProccess: '',
			soProccessID: '',
			tanggalDibuat: [],
			tanggalDibayar: [],
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			params:[],
			headers: [
			{ text: 'Aksi', value: 'action', align: 'left', sortable: false },
			{ text: 'Kode Sales Order', value: 'so_code', width: '15%', sortable: true },
			{ text: 'Tanggal Dibayar', value: 'so_status_paid_datetime', width: '15%', sortable: true },
			{ text: 'Status', value: 'so_status', width: '15%', sortable: true },
			{ text: 'Info Pelanggan', value: 'customer_info', width: '40%', sortable: false },
			],
			headersProduct: [
			{ text: 'Nama Produk', value: 'so_detail_product_name', sortable: false },
			{ text: 'Jumlah Dipesan', value: 'so_detail_quantity_sold', sortable: false, align: 'center' },
			{ text: 'Jumlah Diterima', value: 'so_detail_quantity_received', sortable: false, align: 'center' },
			{ text: 'Jumlah Dikirim', value: 'so_detail_quantity_transport', sortable: false, align: 'center' },
			],
			codeSO: {
				value:'',
				comparison:'like',
				type:'string',
				field: 'so_code'
			},
			codeMB: {
				value:'',
				comparison:'like',
				type:'string',
				field: 'customer_network_code'
			},
			dateCreatedSO: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'so_status_created_datetime'
			},
			datePaidSO: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'so_status_paid_datetime'
			},
			statusSO: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'so_status'
			},
			customer_province: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'customer_province_id'
			},
			customer_city: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'customer_city_id'
			},
			customer_subdistrict: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'customer_subdistrict_id'
			},
		}
	},
	computed: {
		...mapState('so', ['listSO', 'soPagination', 'OptionStatus', 'ProvinceOption', 'CityOption', 'SubdistrictOption']),
	},
	methods: {
		...mapActions('so', ['getSORoam', 'getDetailSO', 'approveSO', 'exportSORoam', 'getProvinceOption', 'getOptionCity', 'getOptionSubdistrict']),
		...mapMutations('so', ['clearDataSO']),

		getData() {
			this.getSORoam(this.queryString({limit:this.limit, page: this.page, params:this.params})).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
			})
		},
		exportData(){
			this.exportSORoam(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		cari() {
			this.params = []
			if(this.codeSO.value)
				this.params.push(this.codeSO)
			if(this.codeMB.value)
				this.params.push(this.codeMB)
			if (this.dateCreatedSO.value) {
				if (this.dateCreatedSO.value.length > 1) {
					this.dateCreatedSO.value.sort()
					let date = this.dateCreatedSO.value.join('::')
					this.dateCreatedSO.value = date
				}
				this.params.push(Object.assign({}, this.dateCreatedSO))
			}
			if (this.datePaidSO.value) {
				if (this.datePaidSO.value.length > 1) {
					this.datePaidSO.value.sort()
					let date = this.datePaidSO.value.join('::')
					this.datePaidSO.value = date
				}
				this.params.push(Object.assign({}, this.datePaidSO))
			}
			if (this.customer_province.value)
				this.params.push(this.customer_province)
			if (this.customer_city.value)
				this.params.push(this.customer_city)
			if (this.customer_subdistrict.value)
				this.params.push(this.customer_subdistrict)
			this.getData()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		resetFilter() {
			this.codeSO.value = ''
			this.tanggalDibayar = []
			this.tanggalDibuat = []
			this.customer_province.value = ''
			this.customer_city.value = ''
			this.customer_subdistrict.value = ''
			this.params = []
			this.getData()
		},
		getDetail(code){
			this.getDetailSO(code).then(()=> {
				this.dialog = true
			})
		},
		printSO(code) {
			this.getDetailSO(code).then(()=> {
				this.dialogPrint = true
			})
		},
		addressText(customer_data) {
			var data = []
			if (customer_data) {
				if (customer_data.customer_address)
					data.push(customer_data.customer_address)
				if (customer_data.customer_subdistrict_name)
					data.push(customer_data.customer_subdistrict_name)
				if (customer_data.customer_city_name)
					data.push(customer_data.customer_city_name)
				if (customer_data.customer_province_name)
					data.push(customer_data.customer_province_name)
			}
			return data.join(', ')
		},
		changeProvince() {
			this.getOptionCity({
				province_id: this.customer_province.value
			})
			this.customer_city.value = ''
			this.customer_subdistrict.value = ''
		},
		changeCity() {
			this.getOptionSubdistrict({
				city_id: this.customer_city.value
			})
			this.customer_subdistrict.value = ''
		},
	},
	async created() {
		this.$store.dispatch('setPageTitle', `Approval Sales Order`)
		await this.getProvinceOption()
		await this.getData()
		this.loading = await false
	},
	beforeDestroy(){
		this.clearDataSO()
	},
	watch: {
		tanggalDibuat(val) {
			this.dateCreatedSO.value = val
		},
		tanggalDibayar(val) {
			this.datePaidSO.value = val
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		},
	}
};
</script>